/**
 * Display helpers.
 *
 * `formatMoney` deliberately does not import the shared money helpers. The BFF sends
 * integer minor units precisely so no float arithmetic happens anywhere, and the
 * browser's only job is to render them — reaching for a shared helper would invite
 * someone to reach for the parsing side of it too and start doing arithmetic here.
 */

export function formatMoney(minor: number, currency: string): string {
  return new Intl.NumberFormat(undefined, {
    style: 'currency',
    currency,
    minimumFractionDigits: 2,
  }).format(minor / 100);
}

export function formatClock(iso: string): string {
  const parsed = new Date(iso);
  if (Number.isNaN(parsed.getTime())) return '—';
  return parsed.toLocaleTimeString(undefined, {
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit',
    hour12: false,
  });
}

export function formatDate(iso: string): string {
  const parsed = new Date(`${iso}T00:00:00Z`);
  if (Number.isNaN(parsed.getTime())) return iso;
  return parsed.toLocaleDateString(undefined, {
    day: '2-digit',
    month: 'short',
    timeZone: 'UTC',
  });
}

export function nightCount(checkIn: string, checkOut: string): number {
  const from = Date.parse(`${checkIn}T00:00:00Z`);
  const to = Date.parse(`${checkOut}T00:00:00Z`);
  if (Number.isNaN(from) || Number.isNaN(to)) return 0;
  return Math.max(0, Math.round((to - from) / 86_400_000));
}

/** Shorten an opaque identifier for display without implying it was truncated. */
export function abbreviate(value: string, keep = 10): string {
  return value.length <= keep + 1 ? value : `${value.slice(0, keep)}\u2026`;
}
